import { ContactList } from "components/ui/ContactList";
import { Building2, UserPlus } from "lucide-react";
import { useManagers } from "context/ManagersContext";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import { InviteManagerDialog } from "./InviteManagerDialog";

interface ManagersListProps {
  onSelectContact: (contactId: number) => void;
  selectedContactId: number | null;
}

export function ManagersList({
  onSelectContact,
  selectedContactId,
}: ManagersListProps) {
  const { managers, loading, error, refresh } = useManagers();
  const { isAdmin, lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Transform managers to include contact info at the top level
  const transformedManagers = managers.map((manager) => ({
    id: manager.contact.id,
    name: manager.contact.name,
    subtitle: manager.propertyManagerName,
  }));

  return (
    <>
      <ContactList
        listId="managers"
        title={locale === "es" ? "Administración" : "Administration"}
        icon={<Building2 className="w-4 h-4 mr-2" />}
        items={transformedManagers}
        loading={loading}
        error={error}
        searchPlaceholder={
          locale === "es" ? "Buscar administrativos..." : "Search administration..."
        }
        selectedId={selectedContactId}
        onSelectItem={onSelectContact}
        getItemName={(item) => item.name}
        getItemSubtitle={(item) => item.subtitle}
        renderTitle={(hasSelected, isExpanded) => (
          <div className="flex items-center justify-between w-full">
            <span
              className={`flex items-center ${
                hasSelected ? "font-semibold text-blue-600" : ""
              }`}
            >
              <Building2 className="w-4 h-4 mr-2" />
              {(locale === "es" ? "Administración" : "Administration") +
                ` (${transformedManagers.length})`}
            </span>
            {isAdmin && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setInviteDialogOpen(true);
                }}
                variant="ghost"
                size="sm"
                className="p-1"
                title={locale === "es" ? "Invitar administrador" : "Invite Manager"}
              >
                <UserPlus className="w-4 h-4" />
              </Button>
            )}
          </div>
        )}
      />
      <InviteManagerDialog
        open={inviteDialogOpen}
        onClose={() => setInviteDialogOpen(false)}
      />
    </>
  );
}
